module.exports = __webpack_public_path__ + "img/linkus-wms.938fdc85.png";